// Generated art for DMTs (deities) and Mala-Ds (maladies), bundled as local
// assets. Produced with the Solvers gpt-image-1 pipeline (medium quality)
// against the Ponos style template — a cinematic desaturated chiaroscuro
// portrait of a figure embodying the ability (deity) or afflicted by the
// malady, in a brutalist concrete corridor. Full roster generated 2026-07-22.
//
// Missing keys fall back to a placeholder frame in the UI, so this is safe to
// grow. To regenerate: scratchpad/genall.mjs.

import type { ImageSourcePropType } from 'react-native';
import { normalizeMaladyId } from './spectrum-tools';

/** DMT (deity) art — key is the tool id (e.g. 'telos'). */
export const DMT_ART: Record<string, ImageSourcePropType> = {
  telos: require('../../assets/deities/telos.png'),
  numa: require('../../assets/deities/numa.png'),
  moyri: require('../../assets/deities/moyri.png'),
  hrmez: require('../../assets/deities/hrmez.png'),
  kyrs: require('../../assets/deities/kyrs.png'),
  krnos: require('../../assets/deities/krnos.png'),
  janus: require('../../assets/deities/janus.png'),
  tkne: require('../../assets/deities/tkne.png'),
  themis: require('../../assets/deities/themis.png'),
  metis: require('../../assets/deities/metis.png'),
  clio: require('../../assets/deities/clio.png'),
  argos: require('../../assets/deities/argos.png'),
  nemos: require('../../assets/deities/nemos.png'),
};

/**
 * Mala-D (malady) art — key is the malady subtype id (e.g. 'plane'). A composite
 * `${toolId}:${subtypeId}` key overrides the plain one where the same subtype id
 * is shared across tools (THEMIS 'dysnomia' vs NEMOS 'akosmia' use different art).
 */
export const MALADY_ART: Record<string, ImageSourcePropType> = {
  plane: require('../../assets/maladies/plane.png'),
  oizys: require('../../assets/maladies/oizys.png'),
  phthisis: require('../../assets/maladies/phthisis.png'),
  aergia: require('../../assets/maladies/aergia.png'),
  akrasia: require('../../assets/maladies/akrasia.png'),
  kakia: require('../../assets/maladies/kakia.png'),
  adrasteia: require('../../assets/maladies/adrasteia.png'),
  homados: require('../../assets/maladies/homados.png'),
  oistros: require('../../assets/maladies/oistros.png'),
  koalemos: require('../../assets/maladies/koalemos.png'),
  oknos: require('../../assets/maladies/oknos.png'),
  chaos: require('../../assets/maladies/chaos.png'),
  aporia: require('../../assets/maladies/aporia.png'),
  amechania: require('../../assets/maladies/amechania.png'),
  atlas: require('../../assets/maladies/atlas.png'),
  ate: require('../../assets/maladies/ate.png'),
  dysnomia: require('../../assets/maladies/dysnomia.png'),
  // NEMOS malady renamed Dysnomia → Akosmia; art file unchanged.
  'nemos:akosmia': require('../../assets/maladies/dysnomia_nemos.png'),
  lethe: require('../../assets/maladies/lethe.png'),
  achlys: require('../../assets/maladies/achlys.png'),
  apate: require('../../assets/maladies/apate.png'),
};

export function dmtArt(toolId: string): ImageSourcePropType | undefined {
  return DMT_ART[toolId];
}

export function maladyArt(subtypeId: string, toolId?: string): ImageSourcePropType | undefined {
  const id = toolId ? normalizeMaladyId(toolId, subtypeId) : subtypeId;
  if (toolId && MALADY_ART[`${toolId}:${id}`]) return MALADY_ART[`${toolId}:${id}`];
  return MALADY_ART[id];
}
